import api from './api';
export const BigCommerceService = {
    searchProducts(query, limit = 10) {
        return api.get('/api/bigcommerce/products', {
            params: { query, limit },
        });
    },
    searchOrders(email, limit = 10) {
        return api.get('/api/bigcommerce/orders', {
            params: { email, limit },
        });
    },
};
